export type Env = Record<string, string>

export const createEnv = (getPreloadedEnv: () => Env): Env => {
  return Object.assign({}, process.env, getPreloadedEnv())
}
